import { IScoreBar } from "@/types";
import { renderExerciseTypePot } from "@/utils/exercises";

interface ScoreBarProps extends IScoreBar {}

const ScoreBar: React.FC<ScoreBarProps> = ({ score, total, type }) => {
    const progressPercentage = ((score / total) * 100).toFixed(0);
    const barColorClass = score / total >= 0.8 ? "bg-[#219653]" : score / total >= 0.5 ? "bg-[#FF8A00]" : "bg-[#C80505]";
    const textColorClass = score / total >= 0.8 ? "text-[#219653]" : score / total >= 0.5 ? "text-[#FF8A00]" : "text-[#C80505]";
    const formattedType = renderExerciseTypePot(type);
  
    return (
      <>
      <div className="w-full flex flex-col lg:flex-row items-start lg:items-center gap-2 lg:gap-8">
        <div className="text-sm md:text-xl font-semibold text-brand-secondary min-w-[170px]">{formattedType}</div>
        <div className="w-full">
          <div className="leading-[117.5%] text-brand text-sm md:text-xl">
            Your score is <span className="font-semibold">{score} out of {total}</span> ({Math.round((score / total) * 100)}%)
          </div>
          <div className="flex gap-3 mt-3 font-medium text-center whitespace-nowrap">
                <div className={`lg:shrink-0 my-auto h-[9px] rounded-[100px] w-full lg:w-[266px] lg:min-w-[266px] relative bg-opacity-20 ${barColorClass}`}>
                  <div className={`h-[9px] rounded-[100px] ${barColorClass}`} style={{ width: `${progressPercentage}%` }}></div>
                </div>
                <div className={`${textColorClass}`}>{score}/{total}</div>
            </div>
        </div>
      </div>
      </>
    );
  };

export default ScoreBar;
